var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 18.9939C20.1361 19.0764 23 19.4919 23 19.4919V14.5121C23 14.5121 20.1361 14.0966 18.2857 14.0141C13.3435 13.7939 10.6565 16.2263 5.71428 16.0061C3.86394 15.9236 0.999998 15.0101 0.999998 15.0101V19.9899C0.999998 19.9899 3.86394 20.9034 5.71428 20.9859C10.6565 21.2061 13.3435 18.7737 18.2857 18.9939Z",
    fill: "url(#paint0_linear_2_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 13.9939C20.1361 14.0764 23 14.4919 23 14.4919V9.5121C23 9.5121 20.1361 9.09656 18.2857 9.01412C13.3435 8.7939 10.6565 11.2263 5.71428 11.0061C3.86394 10.9236 0.999998 10.0101 0.999998 10.0101V14.9899C0.999998 14.9899 3.86394 15.9034 5.71428 15.9859C10.6565 16.2061 13.3435 13.7737 18.2857 13.9939Z",
    fill: "url(#paint1_linear_2_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 8.99394C20.1361 9.07639 23 9.49192 23 9.49192V4.5121C23 4.5121 20.1361 4.09656 18.2857 4.01412C13.3435 3.7939 10.6565 6.22627 5.71428 6.00606C3.86394 5.92361 0.999998 5.01008 0.999998 5.01008V9.98991C0.999998 9.98991 3.86394 10.9034 5.71428 10.9859C10.6565 11.2061 13.3435 8.77373 18.2857 8.99394Z",
    fill: "url(#paint2_linear_2_115)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2_115",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_115"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_115",
    x1: 23,
    y1: 17.002,
    x2: 1,
    y2: 17.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF8A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEA726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DF8A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_115",
    x1: 23,
    y1: 12.5,
    x2: 1,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2151AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2151AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_115",
    x1: 23,
    y1: 7.5,
    x2: 1,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B22419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D7483D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B22419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7483D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmenia);
export default __webpack_public_path__ + "static/media/armenia.db9470be8cf9cf7d2af030318f832d9a.svg";
export { ForwardRef as ReactComponent };